module.exports = __webpack_public_path__ + "img/alabama-green-logo.8b121778.jpg";